const EndMessage: React.FC = () => {
    return (
        <p style={{ textAlign: 'center', color: '#fff', padding: '20px' }}>
            <b>Yay! You have seen it all</b>
        </p>
    )
}

export default EndMessage;